// Garantisce che le webview (app Shoppy/Mumble) abbiano la classe `webview` già pronta sul body.
(function() {
  const keys = ['mumble-app', 'shoppy'];
  const ua = navigator.userAgent ? navigator.userAgent.toLowerCase() : '';
  const isWebview = window.__themeIsWebview ?? keys.some((key) => ua.includes(key));

  if (!isWebview) {
    window.__themeIsWebview = false;
    return;
  }

  window.__themeIsWebview = true;
  if (!document.documentElement.classList.contains('webview')) {
    document.documentElement.classList.add('webview');
  }

  if (document.body) {
    document.body.classList.add('webview');
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      document.body.classList.add('webview');
    });
  }
})();
